import {Component, EventEmitter, HostBinding, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgClass} from '@angular/common';
import {PillColor, PillFill, PillLetter} from '../../../shared/models/pill';

@Component({
  selector: 'motn-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class PillComponent {
  @Input() color?: PillColor;
  @Input() fill: PillFill = 'outline';
  @Input() removable = false;
  @Input() squareLetter?: PillLetter;
  @Input() monospace = false;
  @Input() value?: string | null;
  @Input() disabled = false;
  @Output() remove = new EventEmitter<void>();

  @HostBinding('class.disabled') get isDisabled() { return this.disabled; }

  onRemove(event: MouseEvent): void {
    event.stopPropagation();
    this.remove.emit();
  }

  get classes(): Record<string, boolean> {
    return {
      [`color-${this.color}`]: !!this.color,
      'fill-tint': this.fill === 'tint',
      'fill-solid': this.fill === 'solid',
      monospace: this.monospace,
    };
  }
}
